import React, { Component } from "react";
import { withReportDateControls } from "../../../../shared/containers/containerReportDateControls";
import ContentInnerWrapper from "../../../../shared/contentInnerWrapper";
import SnackbarWrapper from "../../../../shared/items/static/snackbarWrapper";
import Notification from "../../../../shared/items/static/notification";
import ReportTimeRangeList from "../../../sections/reports/reportTimeRangeList";
import getDates from "../../../../shared/services/date.service";
import styles from "./logisticReportTimeRangeForm.module.scss";
import TimeRangeLogisticReport from "./TimeRangeLogisticReport";
import ButtonPrimary from "../../../../shared/items/contols/buttonPrimary";
import { withLogisticReports } from "../../../../shared/containers/containerLogisticReport";
import Icon from "../../../../shared/items/static/icon";
import InputMask from "react-input-mask";

const isInvalidTime = (startDate, startTime, endDate, endTime) => {
  if (startDate === null || startTime == null || endDate === null || endTime === null) {
    return true;
  }

  let startHour = startTime.getHours();
  let startMin = startTime.getMinutes();
  let endHour = endTime.getHours();
  let endMin = endTime.getMinutes();

  let rangeStartDate = new Date(startDate);
  rangeStartDate.setHours(startHour);
  rangeStartDate.setMinutes(startMin);

  let rangeEndDate = new Date(endDate);
  rangeEndDate.setHours(endHour);
  rangeEndDate.setMinutes(endMin);

  return rangeStartDate >= rangeEndDate;
};

class LogisticReportTimeRangeForm extends Component {
  onChangeSearchTerm(e) {
    const { onChangeSearchTermLogisticReport } = this.props;
    onChangeSearchTermLogisticReport(e.target.value);
  }

  onClickButtonView() {
    const {
      viewPanel,
      viewPanelItems,
      onGetControlPointsReports,
      onGetTaskTripsReports,
      reportStartDate,
      reportStartTime,
      reportEndDate,
      reportEndTime,
      searchTerm,
    } = this.props;

    const timeStart = reportStartDate;
    timeStart.setHours(reportStartTime.getHours());
    timeStart.setMinutes(reportStartTime.getMinutes());

    const timeEnd = reportEndDate;
    timeEnd.setHours(reportEndTime.getHours());
    timeEnd.setMinutes(reportEndTime.getMinutes());

    if (viewPanel === viewPanelItems.controPointReports) {
      onGetControlPointsReports({ timeStart, timeEnd, searchTerm });
    }

    if (viewPanel === viewPanelItems.taskTripReports) {
      onGetTaskTripsReports({ timeStart, timeEnd });
    }
  }

  render() {
    const {
      onChangeTimeLogisticReport,
      reportStartDate,
      reportStartTime,
      reportEndDate,
      reportEndTime,
      isReportDateControlsOpen,
      viewPanel,
      viewPanelItems,
      searchTerm,
    } = this.props;

    const startDate = getDates.getNullTimeDateUtcNumber(reportStartDate);
    const endDate = getDates.getNullTimeDateUtcNumber(reportEndDate);
    const currentDate = getDates.getNullTimeDateUtcNumber(new Date());

    const isTimeInvalid = isInvalidTime(reportStartDate, reportStartTime, reportEndDate, reportEndTime);

    const isButtonDisabled =
      !reportStartDate ||
      !reportStartTime ||
      !reportEndDate ||
      !reportEndTime ||
      isNaN(reportStartDate) ||
      isNaN(reportStartTime) ||
      isNaN(reportEndDate) ||
      isNaN(reportEndTime) ||
      startDate > currentDate ||
      startDate > endDate ||
      isTimeInvalid ||
      (viewPanel === viewPanelItems.controPointReports && (searchTerm === null || searchTerm.length < 4));

    return isReportDateControlsOpen ? (
      <ContentInnerWrapper>
        <div className={styles.container_dateTimeWrapper}>
          <div className={styles.container_itemsTimeIntellegence}>
            <TimeRangeLogisticReport onHandleChangeStore={onChangeTimeLogisticReport} valueStore={this.props} />

            <div className={styles.container_itemsTimeButtom}>
              <ButtonPrimary handleClick={this.onClickButtonView.bind(this)} title="Показать на странице" disabled={isButtonDisabled} />
            </div>

            <SnackbarWrapper isOpen={isTimeInvalid}>
              <Notification type="error">
                <p>{`Конечное время (${getDates.getTimeFormat1(reportEndTime)}) не должно быть раньше начального (${getDates.getTimeFormat1(
                  reportStartTime
                )})`}</p>
              </Notification>
            </SnackbarWrapper>
          </div>
          <div className={styles.container_timeRangeList}>
            <ReportTimeRangeList onHandleChangeStore={onChangeTimeLogisticReport} />
          </div>

          <div>
            {viewPanel === viewPanelItems.controPointReports ? (
              <div className={styles.filterAndSearchToolsContainer}>
                <div className={styles.inputStyle}>
                  <InputMask
                    type={"text"}
                    placeholder={"Адрес"}
                    onChange={this.onChangeSearchTerm.bind(this)}
                    value={viewPanel !== viewPanelItems.controPointReports ? "" : searchTerm}
                    disabled={viewPanel !== viewPanelItems.controPointReports}
                  />
                </div>

                <div
                  className={styles.container_searchBtn}
                  onClick={(e) => {
                    e.stopPropagation();

                    if (!isButtonDisabled) {
                      this.onClickButtonView();
                    }
                  }}
                >
                  <Icon name="search" />
                </div>
              </div>
            ) : null}
          </div>
        </div>
      </ContentInnerWrapper>
    ) : null;
  }
}

export default withReportDateControls(withLogisticReports(React.memo(LogisticReportTimeRangeForm)));
